import React, { Component } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OfficeCostGroupLinkItem from '../../../Domain/OfficeCostGroupLinkItem';
import OfficeCostGroupLinkService from '../../../Services/OfficeCostGroupLinkService';

class OfficeCostGroupLinksPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      links: [],
      searchItem: {},
    };

    OfficeCostGroupLinkItem.clickOnEdit = this.props.editFunction || (() => {});
  }

  static convertLinks(items, currencyCode) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        convertedItems.push(new OfficeCostGroupLinkItem(item, currencyCode));
      });
    }
    return convertedItems;
  }

  render() {
    return (
      <div>
        <TabOfDataTable
          type={OfficeCostGroupLinkItem}
          itemList={this.state.links}
          serviceFunction={() =>
            OfficeCostGroupLinkService.GetOfficeCostGroupLinks(this.props.officeId).then((data) => ({
              data: data,
              numberOfElementsInTheTable: data.length,
            }))
          }
          convertDBItemsFunction={(items) => OfficeCostGroupLinksPanel.convertLinks(items, this.props.currencyCode)}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={false}
          searchParamsType={null}
          changeOfItemListFunction={(list) => this.setState({ links: list })}
          errorCode='OCGL47'
          showPagination={false}
        />
      </div>
    );
  }
}

export default OfficeCostGroupLinksPanel;
